import {useRef, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {selectMapInstance, setMapInstance} from '../slices/mapSlice'

export const useMap = () => {
  const dispatch = useDispatch()
  const mapInstance = useSelector(selectMapInstance)
  const mapRef = useRef(mapInstance)

  // Keep the ref in sync with Redux state
  useEffect(() => {
    mapRef.current = mapInstance
  }, [mapInstance])

  // Helper to update the map instance
  useEffect(() => {
    // If the ref is set externally, sync it back to Redux
    if (mapRef.current !== mapInstance) {
      dispatch(setMapInstance(mapRef.current))
    }
  }, [mapInstance, dispatch])

  return {mapRef}
}
